<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12">
        <div>
          
          <!-- <v-btn
            class="ma-2"
            color="primary"
            outlined
            v-if=" selected.length == 1"
            @click="$router.push('/pump-types-edit/'+selected[0].idpump_type_info)"
          >Edit</v-btn>

          <v-btn v-if=" selected.length > 0" text @click="deletePumpTypeInfo" color="red">Delete</v-btn>

          <v-btn class="ma-2" color="primary" @click="$router.push('/pump-types-add')">
            <v-icon left dark>mdi-plus</v-icon>Create Pump Type
          </v-btn>
            
          <v-btn class="ma-2" color="primary" @click="$router.push('/pump-type-add-from-excell')">
            <v-icon left dark>mdi-plus</v-icon>Create Pump Types & Pumps From Excell
          </v-btn> -->
          
          
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-card>
        <v-card-title>
          Pump Type Informations
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          item-key="idpump_type_info"
          :single-select="false"
          show-select
          v-model="selected"
          :headers="headers"
          :items="pumpTypeInfos"
          :search="search"
        >





 <template v-slot:top>
            <v-toolbar flat color="white">
              
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="1000px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on">New Pump Type Info</v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>


 <v-row>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.type" label="Type Starting With" required></v-text-field>
        </v-col>

        <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="editedItem.frequency" label="Frequency" suffix="Hz" required></v-text-field>
        </v-col> -->

        
      </v-row>
      <v-row>
        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field
            v-model="editedItem.max_sand_quantity"
            suffix="gr/m^3"
            label="Max. Sand Quantity"
          ></v-text-field>
        </v-col>
         
        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="editedItem.number_of_vane" suffix="" label="Number Of Vane"></v-text-field>
        </v-col>

        <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="editedItem.degree_of_protection" suffix="" label="Degree Of Protection"></v-text-field>
        </v-col> -->

        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="editedItem.voltage" suffix="V" label="Voltage"></v-text-field>
        </v-col>
        
        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="editedItem.rotation" suffix="" label="Rotation"></v-text-field>
        </v-col>
        
      </v-row>

      <v-row>
        <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field
            v-model="editedItem.max_water_temp"
            suffix="C"
            label="Maximum Water Temp"
          ></v-text-field>
        </v-col> -->

        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.material" suffix="" label="Material"></v-text-field>
        </v-col>
           <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.case" suffix="" label="Case"></v-text-field>
        </v-col>
        
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.diffuser" suffix="" label="Diffuser"></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.impeller" suffix="" label="Impeller"></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.pump_shaft" suffix="" label="Pump Shaft"></v-text-field>
        </v-col>


        <!-- <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.fi_r" suffix="mm" label="Pump Outside Diameter"></v-text-field>
        </v-col>

        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.fi_e" suffix='"' label="Outlet Connection Diameter"></v-text-field>
        </v-col>
 -->


        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.coupling" suffix="" label="Coupling"></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.strainer" suffix="" label="Strainer"></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.valve_cap" suffix="" label="Valve Cap"></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.connection" suffix="" label="Connection"></v-text-field>
        </v-col>
         
        
      </v-row>











                       
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>




        <template v-slot:item.action="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
            <v-icon small @click="deleteItem(item)">delete</v-icon>
          </template>

        </v-data-table>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
// const API_URL = "http://localhost:9090/";

export default {
  name: "HelloWorld",
  data: () => ({
    token: "",
    dialog: false,
    selected: [],
    editPumpTypeInfoId: 100,
    search: "",
    pumpTypeInfos: [],
    headers: [
      {
        text: "Type Starting With",
        align: "left",
        sortable: true,
        value: "type",
        width: 120
      },

      // { text: "Frequency (Hz)", value: "frequency" },
      // { text: "Outlet Connection Diameter (\")", value: "fi_e" },
      { text: "Max. Sand Quantity (gr/m^3)", value: "max_sand_quantity", width: 150 },
      // { text: "Pump Outside Diameter (mm)", value: "fi_r" },
      { text: "Material", value: "material", width: 140 },
      { text: "Number Of Vane", value: "number_of_vane" },
      // { text: "Degree Of Protection", value: "degree_of_protection" },
      { text: "Voltage", value: "voltage" },
      { text: "Rotation", value: "rotation" },
      // { text: "Max. Water Temp (C)", value: "max_water_temp"},
      { text: "Case", value: "case"},
      { text: "Diffuser", value: "diffuser"},
      { text: "Impeller", value: "impeller"},
      { text: "Pump Shaft", value: "pump_shaft"},
      { text: "Coupling", value: "coupling"},
      { text: "Strainer", value: "strainer"},
      { text: "Valve Cap", value: "valve_cap"},
      { text: "Connection", value: "connection" },
      { text: "Actions", value: "action", sortable: false }
    ],

    editedIndex: -1,
    editedItem: {
      idpump_type_info: -1,
      material: "Stainless Steel",
      type: "XSP 20",
      frequency: "50",
      outlet_connection_diameter: 100,
      max_sand_quantity : 200,
      pump_outside_diameter : 300,
      number_of_vane : 3,
      degree_of_protection : "IP 68",
      voltage : "100-200",
      rotation : "Clock Wise",
      max_water_temp : "30",
      case : "Stainless Steel",
      diffuser : "Stainless Steel",
      impeller :  "Stainless Steel",
      pump_shaft  : "Stainless Steel",
      coupling :  "Stainless Steel",
      strainer :  "Stainless Steel",
      valve_cap : "Stainless Steel",
      connection : "Based on NEMA Standarts"
    } ,
        defaultItem: {
      idpump_type_info: -1,
      material: "Stainless Steel",
      type: "XSP 20",
      frequency: "50",
      outlet_connection_diameter: 100,
      max_sand_quantity : 200,
      pump_outside_diameter : 300,
      number_of_vane : 3,
      degree_of_protection : "IP 68",
      voltage : "100-200",
      rotation : "Clock Wise",
      max_water_temp : "30",
      case : "Stainless Steel",
      diffuser : "Stainless Steel",
      impeller :  "Stainless Steel",
      pump_shaft  : "Stainless Steel",
      coupling :  "Stainless Steel",
      strainer :  "Stainless Steel",
      valve_cap : "Stainless Steel",
      connection : "Based on NEMA Standarts"
    } 
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Pump Type Information" : "Edit Pump Type Information";
    },
     
  },

  watch: { 
    dialog(val) {
      val || this.close();
    },
     
  },

  mounted: function() {
    if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
    this.fetchPumpTypeInfos();
  },
  methods: {

editItem(item) {
      this.editedIndex = this.pumpTypeInfos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.selected = [item];
      this.deletePumpTypeInfo();
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        // update
        // Object.assign(this.users[this.editedIndex], this.editedItem);
        this.savePumpTypeInfo(true, this.editedItem);
      } else {
        // save new
        // this.users.push(this.editedItem);
        this.savePumpTypeInfo(false, this.editedItem);
      }
    },

    savePumpTypeInfo: function(isUpdate, item) {
      var targetUrl = isUpdate == false ? "save_pump_type_info" : "update_pump_type_info";

      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + targetUrl,
        data: item
      })
        .then(response => {
          if (response.data == "1")
          this.close();
          this.fetchPumpTypeInfos()
        })
        .catch(function(error) {
          alert(error);
        });
    },

    deletePumpTypeInfo: function() {
      confirm("Are you sure you want to delete this item?") &&
        this.selected.forEach(this.deletePumpTypeInfoRequest);
      this.selected = [];
    },
    deletePumpTypeInfoRequest: function(pumpType) {
      this.$http
        .get(this.$API_URL + "pump-type-info-delete?idpump_type_info=" + pumpType.idpump_type_info)
        .then(result => {
          console.log(result.data);
          if (this.selected.length == 0) this.fetchPumpTypeInfos();
        });
    },
    fetchPumpTypeInfos: function() {
      this.$http.get(this.$API_URL + "pump_types_infos").then(result => {
        this.pumpTypeInfos = result.data;
      });
    }
  }
};
</script>
